import { css } from '@emotion/css'
import { shorthandHelper, spacing } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    width: '100%',
    height: 64,
    display: 'flex',
    alignItems: 'center',
    padding: shorthandHelper([0, spacing.large]),
  }),

  left: css({
    flex: '1 0 auto',
    marginRight: 'auto',
    display: 'flex',
  }),

  right: css({
    flex: '1 0 auto',
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
  }),
}

export default styles
